export const atob = (data: string) =>
  typeof window !== 'undefined' ? window.atob(data) : Buffer.from(data, 'base64').toString('utf8')
export const btoa = (data: string) =>
  typeof window !== 'undefined' ? window.btoa(data) : Buffer.from(data).toString('base64')
